// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"95b573c8","453":"0fec0411","455":"ac2dd827","977":"a8081e36"}[chunkId] + ".chunk.js";
};